import { createFileRoute } from '@tanstack/react-router'
import { Banner } from '@dss/design-system'
import { RequireAuth } from '@dss/auth'
import { usePortalSession } from '../features/session/usePortalSession'
import { AdminShell } from '../components/AdminShell'
import { SyncStateDashboard } from '../features/onboarding/SyncStateDashboard'

const REQUIRED_PERMISSION = 'distributor.integration.1c.view-sync-events'

/** /sync-state — E3.4 / D19 §D19-3. Standalone-страница дашборда состояния
 *  синхронизации 1С. Требует `distributor.integration.1c.view-sync-events`
 *  (OWNER+MANAGER); пользователи без permission получают frontend-banner
 *  вместо «голого» 403 на data-fetch.
 *
 *  Точка входа из sidebar — пункт «Состояние 1С» (см. AdminShell NAV_DISTRIBUTOR),
 *  + drill-down из onboarding wizard step 5. */
export const Route = createFileRoute('/sync-state')({
  component: SyncStateScreen,
})

function SyncStateScreen() {
  return (
    <RequireAuth>
      <SyncStateContent />
    </RequireAuth>
  )
}

function SyncStateContent() {
  const session = usePortalSession()
  const hasPermission = session.data?.role === 'DISTRIBUTOR_OWNER'
    && session.data.permissions.includes(REQUIRED_PERMISSION)

  return (
    <AdminShell active="sync-state" crumbs={<strong>Состояние 1С</strong>}>
      <h1 style={{ marginTop: 0, marginBottom: 16 }}>Состояние синхронизации с 1С</h1>
      {hasPermission ? (
        <SyncStateDashboard />
      ) : (
        <Banner variant="warning" title="Нет доступа">
          Для просмотра состояния 1С нужно право
          {' '}<code>{REQUIRED_PERMISSION}</code>. Обратитесь к владельцу дистрибьютора.
        </Banner>
      )}
    </AdminShell>
  )
}
